<template>
    <form class="mt-5" ref="customize_form" @submit.prevent="Submit">
        <h5 class="mb-1 font-active">Get started</h5>
        <p>* All custom designs start from <span v-if="$country.is_india">₹50,000</span> <span v-else>$2000</span> onwards.  </p>
        <div class="row mt-4">
            <div class="col-md-12 pb-3 column select_block_mod">
                <!-- <BaseInput name="name" :id="''" :required="true" :mode="{invalid: errorMessages.name}" placeholder="Your Name *" type="text" v-model="formData.name" /> -->
                <label for="">Your Name *</label>
                <input type="text" name="name" required :class="{ 'invalid':errorMessages.name }"  v-model="formData.name">
                <span v-if="errorMessages.name" class="error-msg">{{ errorMessages.name.join(" ") }}</span>
            </div>
            <div class="col-md-12 pb-3 column select_block_mod">
                <!-- <BaseInput name="email" :id="''" :required="true" :mode="{invalid: errorMessages.email}" placeholder="Your Email Address *" type="email" v-model="formData.email" /> -->
                <label for="">Your Email Address *</label>
                <input type="email" name="email" required :class="{'invalid': errorMessages.email}" v-model="formData.email">
                <span v-if="errorMessages.email" class="error-msg">{{ errorMessages.email.join(" ") }}</span>
            </div>
            <div class="col-md-12 pb-3 column select_block_mod">
                <!-- <BaseInput name="phone" :id="''" :required="true" :mode="{invalid: errorMessages.phone}" placeholder="Phone Number *" type="number" v-model="formData.phone" /> -->
                <label for="">Phone Number (Optional)</label>
                <input type="text" name="phone" :class="{'invalid': errorMessages.phone}" v-model="formData.phone">
                <span v-if="errorMessages.phone" class="error-msg">{{ errorMessages.phone.join(" ") }}</span>
            </div>
            <div class="col-md-12 pb-3 column">
                <div class="label_mod">
                    <label>{{ $t('jewelry') }} Type *</label>
          
                    <FilterCustomDropDown 
                    type="jewelry" 
                    :sortOptions="sortOptions"
                    v-model="formData.category"/>
                
                    <span v-if="errorMessages.category" class="error-msg">{{ errorMessages.category.join(" ") }}</span>
                </div>
            </div>
            <div class="col-md-12 pb-3 column" v-if="$country.is_india">
                <div class="label_mod">
                    <label>Budget *</label>
                    <FilterCustomDropDown type="price"
                        :priceOptions="priceOptions"
                        v-model="formData.budget"
                    />
                    <span v-if="errorMessages.budget" class="error-msg">{{ errorMessages.budget.join(" ") }}</span>
                </div>
            </div>
            <div class="col-md-12 pb-3 column" v-else>
                <div class="label_mod">
                    <label>Budget *</label>
                    <FilterCustomDropDown 
                    type="price" 
                    :priceOptions="priceOptions"
                    v-model="formData.budget"/>
                    <span v-if="errorMessages.budget" class="error-msg">{{ errorMessages.budget.join(" ") }}</span>
                </div>
            </div>
            <div class="col-md-12 pb-3 column">
                <div class="textarea_box">
                    <label>Your Message </label>
                    <textarea name="message" rows="8" maxlength="512" :class="{'invalid': errorMessages.message}" v-model="formData.message" />
                    <span v-if="errorMessages.message" class="error-msg">{{ errorMessages.message.join(" ") }}</span>
                    <p class="mb-0">  {{formData.message.length}}/512 characters</p>
                </div>
            </div>
            <div class="col-md-12 pb-3 column">
                <div class="textarea_box">
                    <label for="">Upload Images</label>
                    <input type="file" class="file-input" multiple @change="handleFileUpload($event)"/>
                    <span v-if="errorMessages.pictures" class="error-msg mt-2">{{ errorMessages.pictures.join(" ") }}</span>
                </div>  
            </div>
            <div class="col-md-12 pb-3 column">
                <div class="filter_row">
                    <div class="checkbox_custom ms-0" @click="formData.newsletter = !formData.newsletter">
                        <span :class="{ 'checked' : formData.newsletter === true,  'unchecked' : formData.newsletter === false }"></span>
                        <label class="mb-0">Send me updates on new styles and special offers</label>
                    </div>
                </div>
            </div>
            
            <div v-if="!showSuccess" class="col-md-12 pb-3">
                <CommonBasePrimary v-if="showLoader">Please wait...</CommonBasePrimary>
                <CommonBasePrimary v-else type="submit">Submit</CommonBasePrimary>
            </div>
            <div v-if="showSuccess" class="col-md-12 pb-3">
                <div class="alert alert-info mb-0">Thank you. One of our team members will get in touch with you shortly.</div>
            </div>
        </div>
        
    </form>
</template>

<script setup>
    const { $country } = useNuxtApp();
    const { $formatPrice, $toast } = useNuxtApp()

    const sortOptions = [
        { value: '', label: 'Please select', disabled: true },
        { value: 'rings', label: 'Rings' },
        { value: 'earrings', label: 'Earrings' },
        { value: 'pendants', label: 'Pendants' },
        { value: 'bracelets', label: 'Bracelets' },
        { value: 'necklaces', label: 'Necklaces' },
        { value: 'jewelry_sets', label: $country.is_india ? 'Jewellery sets' : 'Jewelry sets' },
    ];
  
    const priceOptions = $country?.is_india ? [
        { value: '', label: 'Please select', disabled: true },
        { value: '50000-80000', label: `${$formatPrice(50000)} - ${$formatPrice(80000)}` },
        { value: '80000-100000', label: `${$formatPrice(80000)} - ${$formatPrice(100000)}` },
        { value: '100000-200000', label: `${$formatPrice(100000)} - ${$formatPrice(200000)}` },
        { value: '200000-300000', label: `${$formatPrice(200000)} - ${$formatPrice(300000)}` },
        { value: '300000-500000', label: `${$formatPrice(300000)} - ${$formatPrice(500000)}` },
        { value: '500000', label: `Above ${$formatPrice(500000)}` },
    ]
    : 
    [
    { value: '', label: 'Please select', disabled: true },
    { value: '2000-3000', label: `${$formatPrice(2000)} - ${$formatPrice(3000)}` },
    { value: '3000-5000', label: `${$formatPrice(3000)} - ${$formatPrice(5000)}` },
    { value: '5000-7000', label: `${$formatPrice(5000)} - ${$formatPrice(7000)}` },
    { value: '7000-10000', label: `${$formatPrice(7000)} - ${$formatPrice(10000)}` },
    { value: '10000', label: `${$formatPrice(10000)} +` },
    ];


    const formData = reactive({
        name: '',
        email: '',
        phone: '',
        category: '',
        budget: '',
        newsletter: true,
        message: '',
    });

    const files = ref('');
    const errorMessages = ref({});
    const showLoader = ref(false);
    const showSuccess = ref(false);

    const handleFileUpload = (event) => {
        files.value = event.target.files;
    };

    const emptyData = () => {
        formData.name = '';
        formData.email = '';
        formData.phone = '';
        formData.category = '';
        formData.budget = '';
        formData.newsletter = true;
        formData.message = '';
        // files.value = [];
    };





const Submit = async () => {
   
        errorMessages.value = {};
        showLoader.value = true;

        let formBody = new FormData();

        for (let i = 0; i < files.value.length; i++) {
            let file = files.value[i];
            formBody.append(`pictures[${i}]`, file);
        }

        let newsletter = formData.newsletter ? 1 : 0;

        formBody.append('name', formData.name);
        formBody.append('email', formData.email);
        formBody.append('phone', formData.phone);
        formBody.append('category', formData.category);
        formBody.append('budget', formData.budget);
        formBody.append('newsletter', newsletter);
        formBody.append('message', formData.message);
        // to consolelog formBody
        // for (let pair of formBody.entries()) {
        //     console.log(pair[0] + ': ' + pair[1]);
        // }
        try {
            const response = await $fetch(useCountryPath('/customise-your-jwelery/store'), {
                method: 'POST',
                body: formData,
            })
        
            if (response.success) {
                showSuccess.value = true
                showLoader.value = false
                emptyData()
            }
           
        }catch(error){
            showLoader.value = false
            if(error.status === 422){
                errorMessages.value = error.data.errors;
            }
            if(error.status === 500){
                $toast('alert',"Something went wrong, Please try again")
            }
            // errorMessages.value = error.data.errors;
        }
    }
    

</script>


<style scoped>
input[type=file]{
    border: 0;
    border-radius: 0;
}
h5{
    font-size: 20px;
}
p{
    color: #6a6161;
    font-size: 14px;
    font-weight: 500;
}
.label_mod{
    text-transform: capitalize;
}
label {
   margin-bottom: 0.5rem;
}

.alert-info {
    color: #0c5460;
    background-color: #d1ecf1;
    border-color: #bee5eb;
}

.select_block_mod label {
    font-size: 14px;
    font-weight: 600;
    display: block;
    color: #363030;
 
}
.select_block_mod input {
    font-size: 16px;
    height: 45px;
    font-weight: 500;
    width: 100%;
    padding: 0 10px;
    outline: none;
}
.select_block_mod input.invalid {
    border: 1px solid red;
}
</style>
